import { useState } from "react";
import Divider from "./Divider";
import { createTheme } from "../../styles/theme";
import { cn } from "../../lib/utils";
import ContactDialog from "../dialogs/ContactDialog";

interface FooterProps {
  isLightMode: boolean;
}

function Footer({ isLightMode }: FooterProps) {
  const theme = createTheme(isLightMode);

  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  // Contact button styles that match navigation menu items
  const contactButtonClasses = cn(
    "px-4 py-2 rounded-xl text-center font-medium transition-all duration-100 hover:scale-110",
    theme.components.button
  );

  return (
    <footer className={`w-full ${theme.colors.bg.primary} mt-auto py-4`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center md:items-end justify-between">
          {/* Copyright text */}
          <div className={`${theme.colors.text.primary} mb-4 md:mb-0 pb-2`}>
            © 2025 Find a Feeling. All rights reserved.
          </div>

          <Divider className="hidden md:block flex-grow mx-8" style={{ marginBottom: "18px" }} />

          {/* Contact button */}
          <button
            className={`${contactButtonClasses} ${theme.colors.text.primary}`}
            onClick={() => setIsContactDialogOpen(true)}
          >
            Contact Us
          </button>

          <ContactDialog
            isOpen={isContactDialogOpen}
            onClose={() => setIsContactDialogOpen(false)}
            isLightMode={isLightMode}
          />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
